import { api } from "./axios";

export async function sectionUpdate(data) {
    let res = await api.post("section/store", data);
    if (res) return res.data.data;
    else return false;
}

export async function getsection(sectionId) {
    let res = await api.get("section/get/" + sectionId);
    if (res) return res.data.data;
    else return false;
}


export async function createAd(data) {
    let res = await api.post("ad/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateAd(id, data) {
    let res = await api.post("ad/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

// export async function getAds(type) {
//     let res = await api.get("ad/index/" + type);
//     if (res) return res.data.data;
//     else return false;
// }
export async function getAds(type) {
    let res = await api.get("ad/getAll/" + type);
    if (res) return res.data.data;
    else return false;
}
// export async function getAdsDetails(id) {
//     let res = await api.get("ad/index/" + id);
//     if (res) return res.data.data;
//     else return false;
// }

export async function changeStatusAd(id, status) {
    let res = await api.get("ad/change/" + id + '/' + status);
    if (res) return res.data.data;
    else return false;
}
export async function deleteAd(id) {
    let res = await api.get("ad/remove/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function getCities() {
    let res = await api.get("cities");
    if (res) return res.data.data;
    else return false;
}

//////////// API Content
export async function getSettings() {
    let res = await api.get("settings");
    if (res) return res.data.data;
    else return false;
}
export async function updateSettings(data) {
    let res = await api.post("settings/store", data);
    if (res) return res.data.data;
    else return false;
}

////////////////////// short reports in home page
export async function getShortReports() {
    let res = await api.get("state/short_reports");
    if (res) return res.data;
    else return false;
}

////////////////////// short reports in home page
export async function getlineChart() {
    let res = await api.get("state/line_chart");
    if (res) return res.data;
    else return false;
}
